/**************************************************
 * Nombre:       Tarjeta_Producto_Dos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Chip, Grid, IconButton, Typography} from "@mui/material";
import {KeyboardArrowLeft, KeyboardArrowRight} from "@mui/icons-material";
import {useEffect, useRef, useState} from "react";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import {useNavigate} from "react-router";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {obtenerPorcentaje} from "../../CodCliente/obtenerPorcentaje";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useFuncionesCarritoLateral} from "../../Modulo_Carrito_Lateral/Hooks/useFuncionesCarritoLateral";
import {adap_producto_carrito_lateral} from "../../Modulo_Carrito_Lateral/Adaptadores/adap_producto_carrito_lateral";
import {useCarritoLateral} from "../../Modulo_Carrito_Lateral/Hooks/useCarritoLateral";

const Tarjeta_Producto_Dos = ({item}) => {
    const {sCell} = useResponsive()
    const navigate = useNavigate();
    const {adicionarProducto} = useFuncionesCarritoLateral()
    const {abrir: abrirCa, Carrito} = useCarritoLateral()
    const [ver, setVer] = useState(false);
    const [imgs, setImgs] = useState([])
    const [etiquetas, setEtiquetas] = useState([])
    const [cargando, setCargando] = useState(false)
    const refe = useRef(null)

    const click = (e, variante) => {
        e.stopPropagation();
        setCargando(true)
        let prod = adap_producto_carrito_lateral({producto: item, variacion: variante, cantidad: 1})

        window.fbq('track', 'AddToCart', {
            content_ids: [prod.nombre],
            content_type: 'product',
            value: prod.valor,
            currency: 'COP'
        });

        adicionarProducto(prod)
        setTimeout(() => {
                abrirCa()
                setCargando(false)
            }, 1000
        )


    }

    const siguiente = (e) => {
        e.stopPropagation();
        if (refe.current) {
            refe.current.splide.go('<');
        }
    };

    const atras = (e) => {
        e.stopPropagation();
        if (refe.current) {
            refe.current.splide.go('>');
        }
    };

    useEffect(() => {

        let arr = []
        if (item.img) {
            arr.push(item.img);
        }

        if (item.imgs) {
            arr.push(...item.imgs);
        }


        setImgs(arr)


        let arrEti = []

        if (item.valorAntes > 0) {
            let descuento = obtenerPorcentaje({valor: item.valor, rebajado: item.valorAntes});
            arrEti.push(descuento + '%');
        }


        if (item.etiquetas) {
            arrEti.push(...item.etiquetas);
        }

        setEtiquetas(arrEti)


    }, [item])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        >

            <Carrito/>

            {imgs.length > 0 &&
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{
                    justifyContent: 'flex-start', zIndex: 1,
                    //   backgroundImage: `url(${item.img})`,
                    //   backgroundRepeat: 'no-repeat',
                    //   backgroundSize: 'cover',
                    //   backgroundPosition: 'center center',

                }}>
                    <Splide
                        ref={refe}
                        aria-label="My Favorite Images" style={{width: '100%'}}
                        options={{
                            autoplay: false,
                            speed: 1000,
                            rewind: true,
                            perPage: 1,
                            arrows: false,
                            pagination: false,
                            width: '100%',
                            drag: 'false',
                            interval: 1000,
                            noDrag: true,
                            type: 'loop',
                            gap: 2
                        }}
                    >

                        {imgs.map((srcImg, index) => {
                            return (
                                <SplideSlide>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        sx={{
                                            //backgroundColor: 'white',
                                            backgroundImage: 'url(' + srcImg + ')',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center center',
                                            minHeight: sCell ? 280 : 370,
                                            width: '100%',
                                            boxShadow: 0,
                                        }}
                                    >


                                    </Grid>
                                </SplideSlide>
                            )
                        })}


                    </Splide>
                </Grid>
            }


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                onClick={() => navigate('/Detalle/' + item.id)}
                onMouseOver={() => setVer(true)}
                onMouseLeave={() => setVer(false)}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    p: sCell ? 1 : 2,
                    mt: sCell ? -35 : -46.5,
                    height: sCell ? 340 : 370,
                    cursor: 'pointer',
                    zIndex: 5
                }}
            >
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}
                      spacing={1}
                >
                    {etiquetas.map((item, index) => (
                        <Chip color={'primary'} sx={{fontSize: 10, pt: 0.3, backgroundColor: '#00000090'}}
                              label={item.toUpperCase()}
                              size={'small'}/>
                    ))}

                </Grid>


                <Grid
                    container
                    justifyContent={'space-between'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{mt: etiquetas.length > 0 && sCell ? 9 : 12, opacity: ver || sCell ? 1 : 0}}
                >

                    <IconButton
                        onClick={(e) => siguiente(e)}
                        sx={{px: sCell ? 0 : 1}}
                    >
                        <KeyboardArrowLeft/>
                    </IconButton>

                    <IconButton
                        onClick={(e) => atras(e)}
                        sx={{px: sCell ? 0 : 1}}
                    >
                        <KeyboardArrowRight/>
                    </IconButton>

                </Grid>

                {item && item.variaciones && item.variaciones.length > 0 && item.variaciones.length <= 4 &&
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{
                            backgroundColor: '#00000090',
                            borderRadius: 20,
                            color: 'white',
                            mt: sCell ? 18 : 13,
                            opacity: ver || sCell ? 1 : 0,
                            py: 0.5
                        }}
                        spacing={2.5}
                    >

                        {item.variaciones.map((it, index) => {

                            if (it.cantidad > 0) {

                                return (
                                    <IconButton
                                        loading={cargando}
                                        onClick={(e) => click(e, it)}
                                        variant={'text'} sx={{
                                        //borderRight: index < item.variaciones.length - 1 ? 1 : 0,
                                        borderColor: '#ffffff40',
                                        color: '#fff',
                                        fontSize: 11,
                                        px: sCell ? 0 : 1,
                                        borderRadius: 0,
                                        transition: 'all .2s ease-in-out',
                                        "&:hover": {
                                            textDecoration: 'underline'
                                        }
                                    }}>{it.nombre.toUpperCase()}</IconButton>
                                )
                            }


                        })}


                    </Grid>

                }


            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    px: 1,
                    mt: 1.5,
                    cursor: 'pointer',
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 14, fontWeight: 500}}>{item.nombre}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 14, fontWeight: 400, lineHeight: 1.2}}>


                        {(item.valorAntes && item.valorAntes > 0) ?

                            <>
                                <span style={{
                                    paddingLeft: 0,
                                    fontSize: 11,
                                    color: '#00000080'
                                }}>Antes: {formatoMoneda(item.valorAntes)}</span>
                                <br/>
                            </>

                            :

                            ''
                        }

                        {formatoMoneda(item.valor)}


                    </Typography>
                </Grid>

            </Grid>

        </Grid>

    )

}
export default Tarjeta_Producto_Dos